import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DriverReferralLinkAdminComponent } from './driver-referral-link-admin.component';

const routes: Routes = [
  {
    path: '',
    component: DriverReferralLinkAdminComponent,
    data: { title: 'Driver Referral Link Admin' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DriverReferralLinkAdminRoutingModule {}

@NgModule({
  imports: [
    DriverReferralLinkAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [DriverReferralLinkAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [DriverReferralLinkAdminComponent],
})
export class DriverReferralLinkAdminModule {}
